<template>
  <div class="homepage-preview">
    <div class="homepage-preview-header">
      <div>Preview Homepage</div>
      <div>
        <v-btn-toggle v-model="viewMode" color="primary" mandatory>
          <v-btn value="desktop" small>Desktop</v-btn>
          <v-btn value="mobile" small>Mobile</v-btn>
        </v-btn-toggle>
      </div>
      <div>
        <v-btn color="primary" @click="$emit('close')">Close</v-btn>
      </div>
    </div>
    <v-card class="homepage-preview-content">
      <div
        class="container-size"
        :class="{ 'container-size-desktop': viewMode === 'desktop', 'container-size-mobile': viewMode === 'mobile' }"
        ref="sectionContainer"
      >
        <div id="view-section-template" v-html="sectionsHtml"></div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { sectionHomepage } from '../common/section-templates/section-template-runtime';
export default {
  name: 'ViewHomepage',
  props: {
    sectionsHtml: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewMode: 'desktop',
    };
  },
  watch: {
    open: {
      handler() {
        this.$nextTick(() => {
          const container = this.$refs.sectionContainer;
          if (!container) return;

          const scriptsSwiper = container.querySelector('script[data-attribute="script-swiper"]');

          if (scriptsSwiper) {
            const newScriptCDN = document.createElement('script');
            newScriptCDN.src = scriptsSwiper.getAttribute('src');
            newScriptCDN.setAttribute('data-ignore', 'true');

            newScriptCDN.onload = () => {
              runOtherScripts();
            };

            scriptsSwiper.parentNode.replaceChild(newScriptCDN, scriptsSwiper);
          } else {
            runOtherScripts();
          }

          function runOtherScripts() {
            const scripts = container.querySelectorAll('script:not([data-executed]):not([data-ignore])');
            scripts.forEach(script => {
              const newScript = document.createElement('script');
              for (const attr of script.attributes) newScript.setAttribute(attr.name, attr.value);
              newScript.text = script.textContent;
              script.parentNode.replaceChild(newScript, script);
              newScript.setAttribute('data-executed', '1');
            });
          }
          sectionHomepage();
        });
      },
      immediate: true,
    },
  },
};
</script>
